import { render, staticRenderFns } from "./blacklist.vue?vue&type=template&id=583db130"
import script from "./blacklist.vue?vue&type=script&lang=js"
export * from "./blacklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('583db130')) {
      api.createRecord('583db130', component.options)
    } else {
      api.reload('583db130', component.options)
    }
    module.hot.accept("./blacklist.vue?vue&type=template&id=583db130", function () {
      api.rerender('583db130', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/redBook/component/blacklist.vue"
export default component.exports